<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Consultation consignation</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Type :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.typeConsignationAfficher"> ... </p>
          <p v-else> {{ consignation.typeConsignationAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Description :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.description"> ... </p>
          <p v-else> {{ consignation.description }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Quantité :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.quantite"> ... </p>
          <p v-else> {{ consignation.quantite }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Numéro de série :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.numeroSerie"> ... </p>
          <p v-else> {{ consignation.numeroSerie }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Fournisseur :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.fournisseur"> ... </p>
          <p v-else> {{ consignation.fournisseur }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Commentaire :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.commentaire"> ... </p>
          <p v-else> {{ consignation.commentaire }} </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Dénomination :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.denominationAfficher"> ... </p>
          <p v-else> {{ consignation.denominationAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Dimension :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.dimension"> ... </p>
          <p v-else> {{ consignation.dimension }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Prix unitaire :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.prix"> ... </p>
          <p v-else> {{ fixDecimalsPrix(consignation.prix) }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Marque :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.marque"> ... </p>
          <p v-else> {{ consignation.marque }} </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Devise :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.deviseAfficher"> ... </p>
          <p v-else> {{ consignation.deviseAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Poids :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.poids"> ... </p>
          <p v-else> {{ consignation.poids }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Montant :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.montant"> ... </p>
          <p v-else> {{ fixDecimalsPrix(consignation.montant) }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col lbl text-vertical-center">
          <label>Modèle :</label>
        </div>
        <div class="col txt">
          <p v-if="!consignation.modele"> ... </p>
          <p v-else> {{ consignation.modele }} </p>
        </div>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="row">
      <div class="col lbl text-vertical-center">
        <label>Approuvable :</label>
      </div>
      <div class="col txt">
        <Checkbox id="approuve" v-model="consignation.approuvable" :binary="true" :disabled="true"/>
      </div>
      <div class="col lbl text-vertical-center">
        <label>Approuvé :</label>
      </div>
      <div class="col txt">
        <Checkbox id="approuve" v-model="consignation.approuve" :binary="true" :disabled="true"/>
      </div>
    </div>
  </div>

  <div class="container p-6 my-6 border">
    <div class="row ">
      <div class="col">
        <div class="row">
          <div class="col lbl text-vertical-center">
            <label>Créé par :</label>
          </div>
          <div class="col txt">
            <p v-if="!consignation.creerParDescription"> ... </p>
            <p v-else> {{ consignation.creerParDescription }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col lbl text-vertical-center">
            <label>Date :</label>
          </div>
          <div class="col txt">
            <p v-if="!consignation.creerLe"> ... </p>
            <p v-else> {{ $commun.formatDateHeure(consignation.creerLe) }} </p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col lbl text-vertical-center">
            <label>Modifié par :</label>
          </div>
          <div class="col txt">
            <p v-if="!consignation.modifierParDescription"> ... </p>
            <p v-else> {{ consignation.modifierParDescription }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col lbl text-vertical-center">
            <label>Date :</label>
          </div>
          <div class="col txt">
            <p v-if="!consignation.modifierLe"> ... </p>
            <p v-else> {{ $commun.formatDateHeure(consignation.modifierLe) }} </p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col lbl text-vertical-center">
            <label>Approuvé par :</label>
          </div>
          <div class="col txt">
            <p v-if="!consignation.approuveParDescription"> ... </p>
            <p v-else> {{ consignation.approuveParDescription }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col lbl text-vertical-center">
            <label>Date :</label>
          </div>
          <div class="col txt">
            <p v-if="!consignation.approuveLe"> ... </p>
            <p v-else> {{ $commun.formatDateHeure(consignation.approuveLe) }} </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="consignation.typeConsignation == 23639">
    <div class="container p-8 my-8 border">
      <label><strong>ATTENTION! Ne pas oublier de contacter le responsable de cet élément consigné.</strong></label>
    </div>
  </div>

  <ButtonBarConsignation ref="buttonBarConsignation" @fermer="fermer"/>

</template>

<script>
import ButtonBarConsignation from '../../../components/dossier/Consulter/ButtonBarConsignation.vue'
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  name: 'ConsulterConsignation',
  components: {
    ButtonBarConsignation
  },
  mounted() {
    this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter une Consignation");
    this.getConsignation();
  },
  data() {
    return {
      isDataLoading: false,
      consignation: {},
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  methods: {
    getConsignation() {
      this.$store.dispatch('consignation/consulterConsignationAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site
      }).then((res) => {
        this.assignerConsignation(res);
        this.calculerMontant();
        this.isDataLoading = false;
        this.$refs.buttonBarConsignation.setModificationDisponible(this.consignation.approuveLe !== null);
      })
    },
    assignerConsignation(res) {
      this.consignation = res.data.entite;
    },
    calculerMontant() {
      if ((this.consignation.prix !== null && this.consignation.prix !== undefined)
          && (this.consignation.quantite !== null && this.consignation.quantite !== undefined)
          && (this.consignation.quantite > 0 && this.consignation.prix > 0)) {
        this.consignation.montant = this.consignation.prix * this.consignation.quantite;
      } else {
        this.consignation.montant = null;
      }
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    fixDecimalsPrix(prix) {
      return parseFloat(prix).toFixed(2);
    },
  }
}
</script>